import React, { useState, useEffect } from "react";
import moment from "moment";
import Modal from "gp-modal";
import "gp-modal/dist/index.css";
import "./style.scss";
import { Form, Tabs, message } from "antd";

import ListaDependentes from "./listaDependentes";
import Services from "./services";

import FormContato from "./FormContato";
import FooterLista from "./FooterLista";
import FooterEdicao from "./FooterEdicao";
import FooterVisualizacao from "./FooterVisualizacao";
import IdentificacaoBase from "../IdentificacaoDoSegurado/Identificacao-base";
import Dependencia from "./Dependencia";

import { useDependenteForm } from "./useDependenteForm";

const { TabPane } = Tabs;

export default function ModalDependente({
  show,
  close,
  cpf,
  pessoaTitular,
  somenteVisualizacao,
}) {
  const [activeKey, setActiveKey] = useState("1");
  const [form] = Form.useForm();
  const { modo, setModo, dependente, carregarDependente, criarNovoDependente } =
    useDependenteForm(form);

  const [submodoVisualizacao, setSubmodoVisualizacao] = useState(false);
  //const dependenteId = form.getFieldValue(["dependente", "id"]);
  const dependenteId = Form.useWatch(
    ["dependente", "id"],
    form
  );

  const [carteirasPendentes, setCarteirasPendentes] = useState([]);

  const handleSelecionar = async (id) => {
    form.resetFields();
    const resp = await Services.searchDependente(id);
    if (!resp || !resp.data) return;

    const dependente = { ...resp.data };

    if (dependente.pessoa) {
      dependente.pessoa = sanitizeDeep(dependente.pessoa);
    }

    carregarDependente(dependente);
  };

  /*const handleNovo = () => {
    setCarteirasPendentes([]);
    const novo = Services.criarDependenteVazio(pessoaTitular);
    criarNovoDependente(novo);
  };*/

  const handleNovo = () => {
    iniciarNovoDependente();
  };

  const sanitizeDeep = (obj) => {
    if (obj === null || obj === undefined) return obj;

    if (moment.isMoment(obj)) return obj;

    if (obj instanceof Date) return obj;

    if (typeof obj === "string") {
      return obj.trim();
    }

    if (Array.isArray(obj)) {
      return obj.map(sanitizeDeep);
    }

    if (typeof obj === "object" && obj !== null) {
      const result = {};
      Object.keys(obj).forEach((key) => {
        result[key] = sanitizeDeep(obj[key]);
      });
      return result;
    }

    return obj;
  };

  useEffect(() => {
    if (modo !== "lista") {
      // força montar abas 2 e 3
      setActiveKey("2");

      setTimeout(() => {
        setActiveKey("3");

        setTimeout(() => {
          setActiveKey("1"); // volta para aba inicial
        }, 0);
      }, 0);
    }
  }, [modo]);

  const normalizarDatas = (obj) => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  // Moment
  if (moment.isMoment(obj)) {
    return obj.format("YYYY-MM-DDTHH:mm:ss");
  }

  // Date
  if (obj instanceof Date) {
    return moment(obj).format("YYYY-MM-DDTHH:mm:ss");
  }

  // String
  if (typeof obj === "string") {
    // YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(obj)) {
      return `${obj}T00:00:00`;
    }

    // Já está no formato de LocalDateTime
    if (/^\d{4}-\d{2}-\d{2}T/.test(obj)) {
      return obj;
    }

    return obj;
  }

  // Array
  if (Array.isArray(obj)) {
    return obj.map(normalizarDatas);
  }

  // Objeto
  if (typeof obj === "object") {
    const novo = {};

    Object.keys(obj).forEach((key) => {
      novo[key] = normalizarDatas(obj[key]);
    });

    return novo;
  }

  return obj;
};

const onSalvar = async () => {
  try {
    await form.validateFields();

    const valores = form.getFieldsValue(true);

    const dependente = normalizarDatas(valores.dependente);

    // NORMALIZAÇÕES

    if (valores.dependente?.endereco) {
      dependente.endereco =
        Services.normalizarEnderecoDependente(
          valores.dependente.endereco
        );
    }

    if (valores.dependente?.contato) {
      dependente.contato =
        Services.normalizarContatoDependente(
          valores.dependente.contato
        );
    }

    dependente.motivoFimDependencia =
      dependente.motivoFimDependencia === undefined ||
      dependente.motivoFimDependencia === null
        ? 0
        : dependente.motivoFimDependencia;

    // Carteiras NÃO fazem parte,Elas serão salvas separadamente depois que a pessoa
    // existir no banco.


    const carteirasNoForm =
      valores.dependente?.pessoa?.carteirasTrabalho || [];

    const carteirasParaSalvar = carteirasPendentes.filter(
      (pendente) => {

        return carteirasNoForm.some((carteira) => {

          // Se ambas possuem ID, compara pelo ID
          if (pendente.id && carteira.id) {
            return pendente.id === carteira.id;
          }

          // Carteira ainda não possui ID:
          // compara pelos dados da carteira
          return (
            String(pendente.numero || "").trim() ===
              String(carteira.numero || "").trim() &&
            String(pendente.serie || "").trim() ===
              String(carteira.serie || "").trim() &&
            String(pendente.localExpedicao || "").trim() ===
              String(carteira.localExpedicao || "").trim() &&
            String(pendente.dataExpedicao || "").substring(0, 10) ===
              String(carteira.dataExpedicao || "").substring(0, 10)
          );
        });
      }
    );

    if (dependente.pessoa) {
      delete dependente.pessoa.carteirasTrabalho;
    }

    // SALVA O DEPENDENTE

    await Services.persistirDependente(dependente);

    // SALVA AS CARTEIRAS QUE REALMENTE ESTÃO PENDENTES

    if (carteirasParaSalvar.length > 0) {
      const cpf = dependente.pessoa?.cpf?.replace(/\D/g, "");

      const { data } = await Services.obterCPF(cpf);

      const pessoaId = data?.pessoa?.id;

      if (!pessoaId) {
        throw new Error(
          "Não foi possível obter a pessoa criada para salvar as carteiras."
        );
      }

      for (const carteira of carteirasParaSalvar) {
        await Services.salvarCarteiraTrabalho({
          ...normalizarDatas(carteira),
          pessoaId,
        });
      }
    }

    // FINALIZA

    message.success("Dependente salvo com sucesso!");

    form.resetFields();

    setCarteirasPendentes([]);

    criarNovoDependente(null);

    setModo("lista");

  } catch (error) {

    if (error?.errorFields?.length) {
      const erro = error.errorFields[0];

      const nivel2 = erro.name[1];

      if (nivel2 === "pessoa") {
        setActiveKey("1");
      } else if (
        nivel2 === "contato" ||
        nivel2 === "endereco"
      ) {
        setActiveKey("3");
      } else {
        setActiveKey("2");
      }

      message.error(
        "Existem campos obrigatórios não preenchidos. Revise o formulário."
      );

      return;
    }

    const mensagemApi =
      error?.response?.data?.mensagem ||
      error?.response?.data?.message;

    if (mensagemApi) {
      message.error(mensagemApi);
      return;
    }

    console.error("Erro ao salvar dependente:", error);

    const mensagem =
      error?.response?.data ||
      "Erro inesperado ao salvar o dependente.";

    message.error(mensagem);
      }
};

  const iniciarNovoDependente = () => {
    setCarteirasPendentes([]);

    const novo = Services.criarDependenteVazio(pessoaTitular);

    criarNovoDependente(novo);
  };

  /*const onSearchCPF = async (cpfDigitado) => {
    try {
      const cpfLimpo = cpfDigitado.replace(/\D/g, "");

      form.resetFields();

      const { data } = await Services.obterCPF(cpfLimpo);

      if (!data) {
        message.error("Nenhum registro encontrado para esse CPF.");
        return;
      }

      if (data.pessoa) {
        data.pessoa = sanitizeDeep(data.pessoa);
      }

      carregarDependente(data);
      message.success("Dados carregados com sucesso!");
    } catch (e) {
      const msg =
        e?.response?.data?.mensagem ||
        e?.response?.data?.message ||
        "Erro ao buscar CPF.";

      message.error(msg);
    }
  };*/

  const obterPessoaTitular = () => {
    const dependenteAtual = form.getFieldValue("dependente");

    return (
      dependenteAtual?.pessoaTitular ||
      dependente?.pessoaTitular ||
      pessoaTitular
    );
  };

  const onSearchCPF = async (cpfDigitado) => {
    const cpfLimpo = cpfDigitado?.replace(/\D/g, "");

    if (!cpfLimpo) {
      return;
    }

    // GUARDA O TITULAR ANTES DE LIMPAR
    const titular = obterPessoaTitular();

    // Limpa o estado das carteiras
    setCarteirasPendentes([]);

    // Limpa o formulário
    form.resetFields();

    try {
      const { data } = await Services.obterCPF(cpfLimpo);

      // =====================================================
      // CPF NÃO ENCONTRADO
      // =====================================================

      if (!data) {
        const novo = Services.criarDependenteVazio(titular);

        // Garante que o titular permaneça
        novo.pessoaTitular = titular;

        // Mantém o CPF digitado
        if (novo.pessoa) {
          novo.pessoa.cpf = cpfDigitado;
        }

        criarNovoDependente(novo);

        message.info(
          "CPF não encontrado. Preencha os dados para cadastrar o dependente."
        );

        return;
      }

      // =====================================================
      // CPF ENCONTRADO
      // =====================================================

      const dependenteEncontrado = {
        ...data,

        // IMPORTANTE:
        // a API pode não retornar o pessoaTitular,
        // então usamos o titular que já estava no formulário.
        pessoaTitular: titular,
      };

      if (dependenteEncontrado.pessoa) {
        dependenteEncontrado.pessoa =
          sanitizeDeep(dependenteEncontrado.pessoa);
      }

      carregarDependente(dependenteEncontrado);

      message.success("Dados carregados com sucesso!");
    } catch (e) {
      const msg =
        e?.response?.data?.mensagem ||
        e?.response?.data?.message ||
        "Erro ao buscar CPF.";

      message.error(msg);

      // Mesmo em erro, mantém o titular e prepara
      // o formulário para uma nova inclusão.
      const novo = Services.criarDependenteVazio(titular);

      novo.pessoaTitular = titular;

      if (novo.pessoa) {
        novo.pessoa.cpf = cpfDigitado;
      }

      criarNovoDependente(novo);
    }
  };




  const salvarCarteira = async (carteira) => {
    const dependenteIdAtual = form.getFieldValue([
      "dependente",
      "id",
    ]);

    const carteiraNormalizada = normalizarDatas(carteira);

    // DEPENDENTE NOVO

    // Ainda não existe no banco.
    // A carteira fica somente em memória.
    if (!dependenteIdAtual) {
      setCarteirasPendentes((prev) => [
        ...prev,
        carteiraNormalizada,
      ]);

      return carteiraNormalizada;
    }

    // DEPENDENTE EXISTENTE

    const pessoaId = form.getFieldValue([
      "dependente",
      "pessoa",
      "id",
    ]);

    if (!pessoaId) {
      throw new Error(
        "Não foi possível identificar a pessoa do dependente."
      );
    }

    const { data } = await Services.salvarCarteiraTrabalho({
      ...carteiraNormalizada,
      pessoaId,
    });

    // Atualiza a lista do formulário caso o componente
    // utilize dependente.pessoa.carteirasTrabalho.

    const path = [
      "dependente",
      "pessoa",
      "carteirasTrabalho",
    ];

    const carteirasAtuais = form.getFieldValue(path) || [];

    form.setFieldValue(path, [
      ...carteirasAtuais,
      data,
    ]);

    return data;
  };

  const excluirCarteira = async (carteira) => {
    const dependenteIdAtual = form.getFieldValue([
      "dependente",
      "id",
    ]);

    // DEPENDENTE NOVO

    if (!dependenteIdAtual) {

      setCarteirasPendentes((prev) =>
        prev.filter(
          (item) =>
            item._tempId !== carteira._tempId
        )
      );

      return;
    }

    // DEPENDENTE EXISTENTE

    if (!carteira) {
      return;
    }

    await Services.excluirCarteiraTrabalho(
      carteira
    );
  };

    const voltarParaLista = () => {
      form.resetFields();
      criarNovoDependente(null);
      setActiveKey("1");
      setModo("lista");
    };

  return (
    <div className="wrapper-modal-dependente">
      <Modal
        className="modal-dependente"
        classNameModal="modal-dependente"
        title={modo === "lista" ? "Dependentes" : "Identificação do Dependente"}
        showModal={show}
        closeModal={close}
        classeSize="modal-xl"
      >
        <div className="modal-body dependente-body">
          {modo === "lista" ? (
            <ListaDependentes
              cpf={cpf}
              onSelecionar={handleSelecionar}
              somenteVisualizacao={somenteVisualizacao}
            />
          ) : (
            <Form form={form} layout="vertical" disabled={somenteVisualizacao}>
              <Tabs
                activeKey={activeKey}
                onChange={setActiveKey}
                destroyInactiveTabPane={false}
              >
                <Tabs.TabPane tab="Identificação" key="1">
                  <IdentificacaoBase
                    modoSomenteLeitura={somenteVisualizacao}
                    disabled={somenteVisualizacao}
                    form={form}
                    nomePrefix={["dependente", "pessoa"]}
                    onSearchCPF={onSearchCPF}
                    onClear={() => form.resetFields(["dependente", "pessoa"])}
                    desabilitarCPF={!!dependenteId}
                    origemCarteira ={"DEPENDENTE"}
                    salvarCarteira ={salvarCarteira}
                    excluirCarteira={excluirCarteira}
                  />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Dependência" key="2">
                  <Dependencia
                    form={form}
                    nomePrefix={["dependente"]}
                    onClear={() => form.resetFields(["dependente"])}
                  />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Contato" key="3">
                  <FormContato
                    form={form}
                    modoSomenteLeitura={somenteVisualizacao}
                    disabled={somenteVisualizacao}
                  />
                </Tabs.TabPane>
              </Tabs>
            </Form>
          )}
        </div>

        {/*<div className="modal-footer p-3">
          {modo === "lista" ? (
            <FooterLista onAdicionar={handleNovo} onClose={close} />
          ) : (
            <FooterEdicao
              form={form}
              onAdicionar={handleNovo}
              onSalvar={onSalvar}
              onVoltar={() => {
                form.resetFields();
                criarNovoDependente(null);
                setModo("lista");
              }}
            />
          )}*/}
        <div className="modal-footer p-3">
          {modo === "lista" ? (
            <FooterLista
              onAdicionar={handleNovo}
              onClose={close}
              somenteVisualizacao={somenteVisualizacao}
            />
          ) : somenteVisualizacao ? (
            <FooterVisualizacao onVoltar={voltarParaLista} />
          ) : (
            <FooterEdicao
              form={form}
              onSalvar={onSalvar}
              onVoltar={voltarParaLista}
            />
          )}
        </div>
      </Modal>
    </div>
  );
}
